// extracted by mini-css-extract-plugin
export var modal = "_48-0";